<template>
    <div>
        <Loader v-if="data.expandLoading"/>
        <table id="expanded-update" v-else-if="data.partnerUpdates && data.partnerUpdates.length && !data.expandLoading">
            <thead>
                <tr>
                    <th>
                        Partner campaign
                    </th>
                    <th>
                        update date
                    </th>
                    <th>
                        spots
                    </th>
                    <th>
                        update status
                    </th>
                    <th>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in data.partnerUpdates" :key="index + item.id">
                    <td>
                        <Campaign :data="item.campaign" :truncate-length="120"/>
                    </td>
                    <td>
                        <Date :data="item.campaign.update_date"/>
                    </td>
                    <td>
                        <SuggestedSpots :data="item" :is-partner-update = 'true'/>
                    </td>
                    <td>
                        <Status :status = 'item.status'/>
                    </td>
                    <td>
                        <Button type="viewUpdate" v-if="item.status === 'posted'">
                            <a 
                                :href="item.campaign.project_url.split('?')[0] + '/posts'"
                                target="_blank"
                                @click="fireEvents(item.campaign.title)"
                            >
                                View Update
                            </a>
                        </Button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
 import { computed, onMounted, ref } from '@vue/composition-api'
import {useRouter} from '../../../../../../core/hooks'
import Button from '../../../Button'
import { Campaign, Status, Date, SuggestedSpots } from '../../../Card/TableComponents'
import {Loader} from '../../../../../../components/Icons'
export default {
    name: 'ExpandedUpdate',
    components: {
        Campaign,
        Status, 
        Date, 
        SuggestedSpots,
        Button,
        Loader
    },
    props: {
        data: Object,
        setPartnerUpdatesData: Function
    },
    mounted(){
        this.$emit('setPartnerUpdates', this.data)
    },
    methods: {
        fireEvents(title){
            this.$ga.event('Dashboard', 'View Update Click', 'Campaign', title)
            this.$sendMixpanelEvent('View Update Link Clicked In Scheduled Updates', {
                'Campaign Name': title
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../../../../../assets/scss/variables.scss';
table#expanded-update {
    width: 100%;
    color: $c6;
    background: $c14;
    border-radius: 15px;
    margin-top: 24px;
    margin-bottom: 24px;
    thead {
        tr {
            height: 50px;
            th {
                font-size: $p5;
                text-transform: uppercase;
                font-weight: $weight_bold;
                text-align: left;

                &:first-child {
                    padding-left: 32px;
                }
            }
        }
    }
    tbody {
        tr {
            height: 56px;
            border-bottom: 1px solid $c28;
            cursor: pointer;
            &:first-child {
                border-top: 1px solid $c28;
            }
                &:last-child {
                    border-bottom: 0 !important;
                }
            td {
                padding-left: 0;
                &:first-child {
                    padding-left: 32px;
                }
            }
        }
    }
}
</style>